import React, { useCallback, useEffect, useState } from 'react';
import { Button, Dropdown } from 'antd';
import CreateUserModal from '../../components/modals/CreateUserModal';
import DeleteModal from '../../components/modals/DeleteModal';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  blockUser,
  unblockUser,
  verifyPendingUser,
  reactivateUser,
  exportUsers,
  fetchUsers,
  removeReferredByDoctor,
} from '../../api/user-api';
import { hardDeleteUser } from '../../api/user-api';
import ContentLayout from '../../layout/ContentLayout';
import TableSection from '../../components/tables/TableSection';
import { userTypeTranslations } from '../../constants/user-constants';
import { useAuth } from '../../context/useAuth';
import { usePermissions } from '../../context/PermissionsContext';
import VerifyUserModal from '../../components/modals/VerifyUserModal';
import dayjs from 'dayjs';
import styles from '../../styles/users.module.scss';
import Search from 'antd/es/transfer/search';
import { toast } from 'react-toastify';
import BlockUserModal from '../../components/modals/BlockUserModal';
import {
  adminAwardLoyaltyPoints,
  adminDeductLoyaltyPoints,
} from '../../api/loyalty-api';
import AwardLoyaltyPointsModal from "../../components/modals/AwardLoyaltyPointsModal";
import DeductLoyaltyPointsModal from '../../components/modals/DeductLoyaltyPointsModal';
import Medics from '../medics';
import AgentTable from '../../components/agent/AgentTable';
import RemoveReferredByDoctorModal from '../../components/modals/RemoveReferredByDoctorModal';
import SetReferredByDoctorModal from '../../components/modals/SetReferredByDoctorModal';
import Spinner from '../../components/elements/Spinner/Spinner';
import { grantVip } from '../../api/vips-api';
import VipValidUntilModal from '../../components/modals/VipValidUntilModal';

const columnsAdmins = [
  {
    key: 'firstName',
    label: 'Korisnik',
    render: (_, row) => {
      const full_name = `${row.firstName || ''} ${row.lastName || ''}`;
      return full_name;
    },
  },
  {
    key: 'email',
    label: 'Email',
    render: (val) => val,
  },
  {
    key: 'phone',
    label: 'Broj telefona',
    render: (val) => val,
  }
];

// The tab bar lives in the header's group slider (router/menu.js), which switches tabs via ?tab=.
const EMBEDDED_TAB_KEYS = ['mentori', 'organizacije', 'agenti'];
// Statuses the API hides from the default user list — all shown in the "Na čekanju" tab
const INACTIVE_USER_STATUSES = ['INACTIVE', 'DELETED'];
const HIDDEN_USER_STATUSES = ['PENDING_VERIFICATION', ...INACTIVE_USER_STATUSES];

export default function Users() {
  const { user } = useAuth();
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10)
  );
  const [totalPages, setTotalPages] = useState(1);
  const [message, setMessage] = useState('');
  const [isBlockUserModalOpen, setIsBlockUserModalOpen] = useState(false);
  const [loadingBlockingUser, setLoadingBlockingUser] = useState(false);
  const [isUnblockUserModalOpen, setIsUnblockUserModalOpen] = useState(false);
  const [unblockUserId, setUnblockUserId] = useState(null);
  const [unblockUserName, setUnblockUserName] = useState(null);
  const [loadingUnblockingUser, setLoadingUnblockingUser] = useState(false);
  const [isVerifyUserModalOpen, setIsVerifyUserModalOpen] = useState(false);
  const [verifyUserId, setVerifyUserId] = useState(null);
  const [verifyUserName, setVerifyUserName] = useState(null);
  const [loadingVerifyingUser, setLoadingVerifyingUser] = useState(false);
  // 'verify' for PENDING_VERIFICATION users, 'reactivate' for INACTIVE/DELETED ones
  const [verifyMode, setVerifyMode] = useState('verify');
  const [loadingDeletingUser, setLoadingDeletingUser] = useState(false);
  const [deleteUserId, setDeleteUser] = useState(null);
  const [deleteUserName, setDeleteUserName] = useState(null);
  const [blockedUserId, setBlockedUserId] = useState(null);
  const [blockUserName, setBlockUserName] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const initialTab = queryParams.get('tab') || 'users';
  const [activeTab, setActiveTab] = useState(initialTab);

  const [filter, setFilter] = useState({
    vipStatus: null,
  });

  const [isAwardPointsModalOpen, setIsAwardPointsModalOpen] = useState(false);
  const [awardPointsUser, setAwardPointsUser] = useState(null);
  const [isDeductPointsModalOpen, setIsDeductPointsModalOpen] = useState(false);
  const [deductPointsUser, setDeductPointsUser] = useState(null);
  const [loadingAwardPoints, setLoadingAwardPoints] = useState(false);
  const [loadingDeductPoints, setLoadingDeductPoints] = useState(false);
  const [isRemoveReferralModalOpen, setIsRemoveReferralModalOpen] = useState(false);
  const [removeReferralUser, setRemoveReferralUser] = useState(null);
  const [loadingRemoveReferral, setLoadingRemoveReferral] = useState(false);
  const [isSetReferralModalOpen, setIsSetReferralModalOpen] = useState(false);
  const [setReferralUser, setSetReferralUser] = useState(null);
  const [isGrantVipModalOpen, setIsGrantVipModalOpen] = useState(false);
  const [grantVipUser, setGrantVipUser] = useState(null);
  const [loadingGrantVip, setLoadingGrantVip] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  // Comes straight from the list response's pagination block, so it always
  // matches the tab, filters and search currently in effect.
  const [totalUsers, setTotalUsers] = useState(0);

  const vipStatusOptions = [
    { label: 'Neaktivan', value: 'inactive' },
    { label: 'Na čekanju', value: 'pending' },
    { label: 'Aktivan', value: 'active' },
    { label: 'Istekao', value: 'expired' },
    { label: 'Otkazan', value: 'cancelled' },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      // Reset to page 1 when search changes
      if (search !== debouncedSearch) {
        setCurrentPage(1);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [search, debouncedSearch]);

  // Tabs of this page the user's permissions allow (see router/menu.js). Opening a hidden
  // tab by URL moves to the first allowed one instead of showing a page of 403s.
  const { can, canAll, visibleMenuGroups } = usePermissions();
  const allowedTabs =
    visibleMenuGroups.find((group) => group.key === 'korisnici')?.tabs ?? [];
  useEffect(() => {
    if (allowedTabs.length && !allowedTabs.some((t) => t.tab === activeTab)) {
      // Through the page's own tab switch, so the URL-sync effect below writes the new tab
      // instead of restoring the hidden one.
      handleTabChange(allowedTabs[0].tab);
    }
  }, [activeTab, allowedTabs.length]); // eslint-disable-line

  // The header slider changes ?tab= by navigating, so follow it here.
  const urlTab = queryParams.get('tab') || 'users';
  useEffect(() => {
    if (urlTab !== activeTab) handleTabChange(urlTab);
  }, [urlTab]); // eslint-disable-line

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set('tab', activeTab);
    params.set('page', currentPage);
    navigate({ search: params.toString() }, { replace: true });
  }, [activeTab, currentPage]); // eslint-disable-line

  console.log('filter', filter);
  console.log('activeTab', activeTab);
  console.log('debouncedSearch', debouncedSearch);

  const loadUsers = useCallback(async () => {
    if (EMBEDDED_TAB_KEYS.includes(activeTab)) return;

    let appliedFilters = { ...filter };

    if (activeTab === 'users') {
      appliedFilters.role = 'client';
    } else if (activeTab === 'admins') {
      appliedFilters.role = 'admin';
    } else if (activeTab === 'pending') {
      // All accounts hidden from the other tabs, regardless of role
      appliedFilters.status = HIDDEN_USER_STATUSES.join(',');
    }

    const { data, success, message } = await fetchUsers({
      page: currentPage,
      limit: 10,
      filter: appliedFilters,
      search: debouncedSearch,
    });

    if (success) {
      setUsers(data.users);
      setTotalPages(data?.pagination?.totalPages);
      setTotalUsers(data?.pagination?.totalItems ?? 0);
    } else {
      console.log(message || 'Error while fetching the users.');
    }
    setTableLoading(false);
  }, [filter, debouncedSearch, currentPage, activeTab]);

  useEffect(() => {
    loadUsers();
    // eslint-disable-next-line
  }, [filter, debouncedSearch, currentPage, activeTab]);

  const handleCreateUserModalClose = () => {
    setIsCreateUserModalOpen(false);
    setCurrentPage(1);
    setSearch('');
    loadUsers();
  };

  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };

  const handleBlockUserModalClose = () => {
    setIsBlockUserModalOpen(false);
  };

  const handleUnblockUser = async () => {
    setLoadingUnblockingUser(true);
    toast.loading('Odblokiravanje korisnika...');
    const userId = unblockUserId;
    try {
      const { success, message } = await unblockUser(userId);

      if (!success) {
        toast.dismiss();
        toast.error(message || 'Greška pri odblokiranju korisnika');
        return;
      }

      setIsUnblockUserModalOpen(false);
      toast.dismiss();
      toast.success('Korisnik odblokiran');
      loadUsers();
    } finally {
      setLoadingUnblockingUser(false);
      setUnblockUserId(null);
    }
  };

  const handleUnblockUserModalClose = () => {
    setIsUnblockUserModalOpen(false);
    setUnblockUserId(null);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    setSearch('');
    setDebouncedSearch('');
    setFilter({});
    setUsers([]);
    // Otherwise the previous tab's count lingers until the new one loads.
    setTotalUsers(0);
    if (!EMBEDDED_TAB_KEYS.includes(key)) setTableLoading(true);
  };

  const handleBlockUser = async () => {
    setLoadingBlockingUser(true);
    toast.loading('Blokiranje korisnika...');
    const userId = blockedUserId;
    try {
      const { success, message } = await blockUser(userId);

      if (!success) {
        toast.dismiss();
        toast.error(message || `Greška pri blokiranju korisnika`);
        setLoadingBlockingUser(false);
        setBlockedUserId(null);
        return;
      }

      setIsBlockUserModalOpen(false);
      toast.dismiss();
      toast.success(`Korisnik blokiran`);
      loadUsers();
      setTimeout(() => {
        setLoadingBlockingUser(false);
      }, 1000);
    } finally {
      setLoadingBlockingUser(false);
      setBlockedUserId(null);
    }
  };

  const handleVerifyUserModalClose = () => {
    setIsVerifyUserModalOpen(false);
    setVerifyUserId(null);
  };

  const handleVerifyUser = async () => {
    setLoadingVerifyingUser(true);
    const isReactivate = verifyMode === 'reactivate';
    toast.loading(isReactivate ? 'Reaktivacija korisnika...' : 'Verifikacija korisnika...');
    const userId = verifyUserId;
    try {
      const { success, message } = isReactivate
        ? await reactivateUser(userId)
        : await verifyPendingUser(userId);

      if (!success) {
        toast.dismiss();
        toast.error(
          message ||
            (isReactivate ? 'Greška pri reaktivaciji korisnika' : 'Greška pri verifikaciji korisnika')
        );
        return;
      }

      setIsVerifyUserModalOpen(false);
      toast.dismiss();
      toast.success(isReactivate ? 'Korisnik reaktiviran' : 'Korisnik verifikovan');
      loadUsers();
    } finally {
      setLoadingVerifyingUser(false);
      setVerifyUserId(null);
    }
  };

  const handleGrantVipModalClose = () => {
    setIsGrantVipModalOpen(false);
    setGrantVipUser(null);
  };

  const handleGrantVip = async (validUntil) => {
    setLoadingGrantVip(true);
    toast.loading('Aktiviranje VIP članstva...');
    const userId = grantVipUser._id;
    try {
      const { success, message } = await grantVip(userId, validUntil);

      if (!success) {
        toast.dismiss();
        toast.error(message || 'Greška pri aktiviranju VIP članstva');
        return;
      }

      setIsGrantVipModalOpen(false);
      setGrantVipUser(null);
      toast.dismiss();
      toast.success('VIP članstvo je uspešno aktivirano');
      loadUsers();
    } finally {
      setLoadingGrantVip(false);
    }
  };

  const handleDeleteUser = async () => {
    const userId = deleteUserId;
    toast.loading('Brisanje korisnika...');

    setLoadingDeletingUser(true);
    const { success, message } = await hardDeleteUser(userId);

    if (!success) {
      setMessage(message);
      toast.dismiss();
      toast.error(message || 'Greška pri brisanju korisnika');
    } else {
      setIsDeleteModalOpen(false);
      toast.dismiss();
      toast.success(`Korisnik obrisan`);
      setMessage(message || 'Korisnik obrisan');
      loadUsers();
      setTimeout(() => {
        setLoadingDeletingUser(false);
        setDeleteUser(null);
      }, 1000);
    }
  };

  const columns = [
    {
      key: 'firstName',
      label: 'Korisnik',
      render: (_, row) => {
        const full_name = `${row.firstName || ''} ${row.lastName || ''}`;
        return full_name;
      },
    },
    {
      key: 'email',
      label: 'Email',
      render: (val) => userTypeTranslations[val] || val,
    },
    {
      key: 'phone',
      label: 'Broj telefona',
      render: (val) => val,
    },
    // {
    //   key: 'role',
    //   label: 'VIP Status',
    //   render: (val) => {
    //     return (
    //       <span className={val}>
    //         {userRoleTranslations[val] === 'Admin' ? 'Da' : 'Ne'}
    //       </span>
    //     );
    //   },
    // },
    {
      key: 'createdAt',
      label: 'Datum registracije',
      render: (val) => {
        const not_null_val = val;
        const date = dayjs(not_null_val).format('DD.MM.YYYY.');
        return <span className={val}>{date}</span>;
      },
    },
    {
      key: 'loyaltyPoints',
      label: 'Poeni',
      render: (val) => <span>{val ?? 0}</span>,
    },
    {
      // TODO:
      key: '',
      label: 'Referral link',
      render: (_, row) => {
        return (
          <span style={{ color: '#005844' }}>{row.referralCode || '-'}</span>
        );
      },
    },
    {
      key: 'referredByDoctor',
      label: 'Mentorski kod',
      render: (_, row) => (
        <span>{row.referredByDoctor?.referralCode || '-'}</span>
      ),
    },
  ];

  const handleCopyLink = (item) => {
    const referralCode = item.referralCode;
    if (!referralCode) return;
    navigator.clipboard
      .writeText(referralCode)
      .then(() => {
        toast.success('Referral kod kopiran');
      })
      .catch((err) => console.error(`Error: ${err}`));
  };

  const onSearchUsers = (value) => {
    setSearch(value);
  };

  const handleViewOrders = (userId, firstName, lastName) => {
    navigate(`/korisnik/narudzbine/${userId}`, {
      state: {
        firstName,
        lastName,
        from: location.pathname + location.search,
      },
    });
  };

  const handleViewPersonalSurvey = (id, firstName, lastName) => {
    navigate(`/korisnik/detalji/${id}`, {
      state: {
        firstName,
        lastName,
        from: location.pathname + location.search,
      },
    });
  };

  const handleAwardPoints = async (points) => {
    setLoadingAwardPoints(true);
    const userId = awardPointsUser._id;
    const prevPoints = awardPointsUser.loyaltyPoints ?? 0;

    setUsers((prev) =>
      prev.map((u) => u._id === userId ? { ...u, loyaltyPoints: prevPoints + points } : u)
    );
    setIsAwardPointsModalOpen(false);
    setAwardPointsUser(null);

    const { success, message } = await adminAwardLoyaltyPoints(userId, points);

    if (!success) {
      setUsers((prev) =>
        prev.map((u) => u._id === userId ? { ...u, loyaltyPoints: prevPoints } : u)
      );
      toast.error(message || 'Greška pri dodavanju poena');
    } else {
      toast.success(`Poeni uspešno dodati`);
    }

    setLoadingAwardPoints(false);
  };

  const handleDeductPoints = async (points, deductionMessage) => {
    setLoadingDeductPoints(true);
    const userId = deductPointsUser._id;
    const prevPoints = deductPointsUser.loyaltyPoints ?? 0;

    setUsers((prev) =>
      prev.map((u) => u._id === userId ? { ...u, loyaltyPoints: Math.max(0, prevPoints - points) } : u)
    );
    setIsDeductPointsModalOpen(false);
    setDeductPointsUser(null);

    const { success, message } = await adminDeductLoyaltyPoints(
      userId,
      points,
      deductionMessage
    );

    if (!success) {
      setUsers((prev) =>
        prev.map((u) => u._id === userId ? { ...u, loyaltyPoints: prevPoints } : u)
      );
      toast.error(message || 'Greška pri oduzimanju poena');
    } else {
      toast.success(`Poeni uspešno oduzeti`);
    }

    setLoadingDeductPoints(false);
  };

  const handleRemoveReferredByDoctor = async () => {
    setLoadingRemoveReferral(true);
    const userId = removeReferralUser._id;
    const { success, message } = await removeReferredByDoctor(userId);
    if (!success) {
      toast.error(message || 'Greška pri uklanjanju mentorske preporuke');
    } else {
      toast.success('Mentorska preporuka je uklonjena');
      setIsRemoveReferralModalOpen(false);
      setRemoveReferralUser(null);
      loadUsers();
    }
    setLoadingRemoveReferral(false);
  };

  const renderTable = (
    state,
    emptyState = {
      icon: '/assets/icons/no-users.svg',
      title: 'Trenutno nema korisnika',
    },
    showFilter = true,
    rowClassName = () => ''
  ) => {
    const actions = activeTab === 'pending'
      ? [
          {
            key: 'verify-pending',
            label: 'Verifikuj korisnika',
            icon: <img src="/assets/icons/verification.svg" alt="Verify" />,
            onClick: (u) => {
              setVerifyMode('verify');
              setVerifyUserId(u._id);
              setVerifyUserName(`${u.firstName} ${u.lastName}`);
              setIsVerifyUserModalOpen(true);
            },
            disabled: () => !can('users:status'),
            visible: (u) => u.status === 'PENDING_VERIFICATION',
          },
          {
            key: 'reactivate',
            label: 'Reaktiviraj korisnika',
            icon: <img src="/assets/icons/verification.svg" alt="Reactivate" />,
            onClick: (u) => {
              setVerifyMode('reactivate');
              setVerifyUserId(u._id);
              setVerifyUserName(`${u.firstName} ${u.lastName}`);
              setIsVerifyUserModalOpen(true);
            },
            disabled: () => !can('users:status'),
            visible: (u) => INACTIVE_USER_STATUSES.includes(u.status),
          },
        ]
      : [
          {
            key: 'header',
            label: 'Opcije',
            disabled: true, // Makes it non-clickable
            className: 'dropdown-header',
          },
          {
            key: 'copy',
            label: 'Kopiraj referral link',
            icon: <img src="/assets/icons/copy.svg" alt="View" />,
            onClick: (item) => handleCopyLink(item),
            // onClick: (user) => navigate(`/korisnik/${user._id}`),
            visible: () => state.copyReferralLink,
          },
          {
            key: 'award-points',
            label: 'Dodaj poene',
            icon: <img src="/assets/icons/edit-icon.svg" alt="Award points" />,
            onClick: (user) => {
              setAwardPointsUser(user);
              setIsAwardPointsModalOpen(true);
            },
            visible: (user) =>
              user.status !== 'archived' && canAll(['loyalty:manage', 'scope:all']),
          },
          {
            key: 'deduct-points',
            label: 'Oduzmi poene',
            icon: <img src="/assets/icons/edit-icon.svg" alt="Deduct points" />,
            onClick: (user) => {
              setDeductPointsUser(user);
              setIsDeductPointsModalOpen(true);
            },
            visible: (user) =>
              user.status !== 'archived' && canAll(['loyalty:manage', 'scope:all']),
          },
          {
            key: 'view-personal-details',
            label: 'Vidi detalje',
            icon: <img src="/assets/icons/view-icon.svg" alt="Archive" />,
            onClick: (user) =>
              handleViewPersonalSurvey(user._id, user.firstName, user.lastName),
            visible: (user) => user.status !== 'archived',
          },
          {
            key: 'view-orders',
            label: 'Vidi porudžbine',
            icon: <img src="/assets/icons/view-icon.svg" alt="Archive" />,
            onClick: (user) =>
              handleViewOrders(user._id, user.firstName, user.lastName),
            visible: (user) => user.status !== 'archived',
          },
          {
            key: 'grant-vip',
            label: 'Aktiviraj VIP',
            icon: <img src="/assets/icons/verification.svg" alt="Aktiviraj VIP" />,
            onClick: (user) => {
              setGrantVipUser(user);
              setIsGrantVipModalOpen(true);
            },
            visible: (user) => activeTab === 'users' && user.vip?.status !== 'active',
            disabled: () => !can('users:write'),
          },
          {
            key: 'block-unblock',
            label: (user) => user.status === 'SUSPENDED' ? 'Odblokiraj nalog' : 'Blokiraj nalog',
            icon: <img src="/assets/icons/block.svg" alt="Block/Unblock" />,
            onClick: (user) => {
              if (user.status === 'SUSPENDED') {
                setUnblockUserId(user._id);
                setUnblockUserName(`${user.firstName} ${user.lastName}`);
                setIsUnblockUserModalOpen(true);
              } else {
                setBlockedUserId(user._id);
                setBlockUserName(`${user.firstName} ${user.lastName}`);
                setIsBlockUserModalOpen(true);
              }
            },
            // Staff accounts can't be blocked (the API refuses it too).
            visible: (user) =>
              !['admin', 'super_admin'].includes(user.role) && can('users:status'),
          },
          {
            key: 'set-referral',
            label: (user) =>
              user.referredByDoctor
                ? 'Promeni mentorsku preporuku'
                : 'Postavi mentorsku preporuku',
            icon: <img src="/assets/icons/edit-icon.svg" alt="Set referral" />,
            onClick: (user) => {
              setSetReferralUser(user);
              setIsSetReferralModalOpen(true);
            },
            visible: () => can('users:write'),
          },
          {
            key: 'remove-referral',
            label: 'Ukloni mentorsku preporuku',
            icon: <img src="/assets/icons/delete.svg" alt="Remove referral" />,
            onClick: (user) => {
              setRemoveReferralUser(user);
              setIsRemoveReferralModalOpen(true);
            },
            visible: (user) => !!user.referredByDoctor && can('users:write'),
          },
          ...(can('users:delete')
            ? [
                {
                  key: 'delete',
                  label: 'Trajno obriši nalog',
                  icon: <img src="/assets/icons/delete.svg" alt="Delete" />,
                  className: 'delete',
                  onClick: (user) => {
                    setDeleteUser(user._id);
                    setDeleteUserName(`${user.firstName} ${user.lastName}`);
                    setIsDeleteModalOpen(true);
                  },
                  danger: true,
                  // Every role except super_admin can be hard-deleted (backend enforces this too).
                  visible: (u) => u.role !== 'super_admin',
                },
              ]
            : []),
        ];

    return (
      <TableSection
        columns={state.columns}
        rowClassName={rowClassName}
        actions={actions}
        data={state.data}
        emptyState={emptyState}
        showPagination={state.data?.length > 0}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        searchPlaceholder="Pretraži"
      />
    );
  };

  const handleExportUsers = async () => {
    let exportRole = undefined;

    if (activeTab === 'admins') {
      exportRole = 'admin';
    }

    const result = await exportUsers({
      role: exportRole,
      search: debouncedSearch,
    });

    if (!result.success) {
      toast.error(result.message);
    } else if (result.data === null) {
      toast.info(result.message);
    } else {
      toast.success('Korisnici uspešno izvezeni');
    }
  };
  
  console.log('users', users);

  const totalLabels = {
    users: 'Ukupno korisnika',
    admins: 'Ukupno admina',
    pending: 'Ukupno na čekanju',
  };

  // The count tracks whatever is currently narrowing the list, so say when it
  // is a filtered subset rather than the full figure.
  const isNarrowed =
    !!debouncedSearch ||
    Object.values(filter).some((val) => val !== null && val !== '');

  return (
    <>
      <ContentLayout>
        {!EMBEDDED_TAB_KEYS.includes(activeTab) && (
          <div className={styles.totalCountRow}>
            <div className={styles.totalCount}>
              <span className={styles.totalCount__label}>
                {totalLabels[activeTab] || 'Ukupno'}
              </span>
              <span className={styles.totalCount__value}>
                {new Intl.NumberFormat('de-DE').format(totalUsers)}
              </span>
              {isNarrowed && (
                <span className={styles.totalCount__hint}>(filtrirano)</span>
              )}
            </div>
          </div>
        )}
        {activeTab === 'users' && (
          <>
            <div className={`${styles.wrapper} users_wrapper`}>
              <div className={styles.filters}>
                <div>
                  <Search
                    placeholder={'Pretraži'}
                    className="search-input"
                    allowClear
                    enterButton
                    onChange={(e) => onSearchUsers(e.target.value)}
                    width="auto"
                  />
                </div>
                <Button
                  className={`btn-tertiary`}
                  onClick={handleExportUsers}
                  icon={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path d="M8 12L3 7h3V1h4v6h3L8 12z" />
                      <path d="M1 14h14v2H1z" />
                    </svg>
                  }
                >
                  Izvezi
                </Button>
              </div>
              <>
                {tableLoading ? <Spinner size="lg" /> : renderTable(
                  {
                    data: users,
                    columns: columns,
                    copyReferralLink: true,
                  },
                  {
                    icon: '/assets/icons/no-users.svg',
                    title: 'Nema korisnika',
                    description: 'Napravite korisnika',
                  },
                  true,
                  (user) => user.status === 'SUSPENDED' ? 'row--suspended' : ''
                )}
              </>
            </div>
          </>
        )}

        {activeTab === 'admins' && (
          <>
            <div className={`${styles.wrapper} admins_wrapper`}>
              <div className={styles.filters}>
                <div>
                  <Search
                    placeholder={'Pretraži'}
                    className="search-input"
                    allowClear
                    enterButton
                    onChange={(e) => onSearchUsers(e.target.value)}
                    width="auto"
                  />
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                    className={`btn-tertiary`}
                    onClick={handleExportUsers}
                    icon={
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                      >
                        <path d="M8 12L3 7h3V1h4v6h3L8 12z" />
                        <path d="M1 14h14v2H1z" />
                      </svg>
                    }
                  >
                    Izvezi
                  </Button>
                  <Button
                    className={`btn-primary`}
                    type="primary"
                    onClick={() => setIsCreateUserModalOpen(true)}
                  >
                    Dodaj admina
                  </Button>
                </div>
              </div>
              <>
                {tableLoading ? <Spinner size="lg" /> : renderTable(
                  {
                    data: users,
                    columns: columnsAdmins,
                  },
                  {
                    icon: '/assets/icons/no-users.svg',
                    title: 'Nema admina',
                    description: 'Napravite admina',
                  },
                  false
                )}
              </>
            </div>
          </>
        )}
        {activeTab === 'mentori' && <Medics embedded initialTab="svi" />}
        {activeTab === 'organizacije' && <Medics embedded initialTab="clinic" />}
        {activeTab === 'agenti' && <AgentTable />}
        {activeTab === 'pending' && (
          <>
            <div className={`${styles.wrapper} pending_wrapper`}>
              <div className={styles.filters}>
                <div>
                  <Search
                    placeholder={'Pretraži'}
                    className="search-input"
                    allowClear
                    enterButton
                    onChange={(e) => onSearchUsers(e.target.value)}
                    width="auto"
                  />
                </div>
              </div>
              <>
                {tableLoading ? <Spinner size="lg" /> : renderTable(
                  {
                    data: users,
                    columns: columns,
                  },
                  {
                    icon: '/assets/icons/no-users.svg',
                    title: 'Nema korisnika na čekanju',
                    description: 'Trenutno nema neverifikovanih, neaktivnih ni obrisanih korisnika',
                  },
                  false,
                  (u) => (INACTIVE_USER_STATUSES.includes(u.status) ? styles.inactiveRow : '')
                )}
              </>
            </div>
          </>
        )}
      </ContentLayout>
      <CreateUserModal
        isOpen={isCreateUserModalOpen}
        onClose={handleCreateUserModalClose}
        onCreate={loadUsers}
      />
      <DeleteModal
        visible={isDeleteModalOpen}
        onDelete={handleDeleteUser}
        onCancel={handleDeleteModalClose}
        loading={loadingDeletingUser}
        title="Trajno brisanje korisnika"
        message={`Da li ste sigurni da želite da trajno obrišete korisnika ${deleteUserName}? Nalog se ne može vratiti, email postaje slobodan za novu registraciju, a istorija porudžbina ostaje sačuvana.`}
        buttonText="Trajno obriši"
        cancelText="Odustani"
      />
      <BlockUserModal
        visible={isBlockUserModalOpen}
        onBlockUser={handleBlockUser}
        onCancel={handleBlockUserModalClose}
        loading={loadingBlockingUser}
        title="Blokiranje korisnika"
        message={`Da li ste sigurni da želite da blokirate korisnika ${blockUserName}?`}
        buttonText="Blokiraj korisnika"
        cancelText="Odustani"
      />
      <BlockUserModal
        visible={isUnblockUserModalOpen}
        onBlockUser={handleUnblockUser}
        onCancel={handleUnblockUserModalClose}
        loading={loadingUnblockingUser}
        title="Odblokiravanje korisnika"
        message={`Da li ste sigurni da želite da odblokirate korisnika ${unblockUserName}?`}
        buttonText="Odblokiraj korisnika"
        cancelText="Odustani"
      />
      <VipValidUntilModal
        mode="grant"
        isOpen={isGrantVipModalOpen}
        onClose={handleGrantVipModalClose}
        onConfirm={handleGrantVip}
        loading={loadingGrantVip}
        userName={
          grantVipUser
            ? `${grantVipUser.firstName} ${grantVipUser.lastName}`
            : ''
        }
      />
      <AwardLoyaltyPointsModal
        onConfirm={handleAwardPoints}
        onClose={() => {
          setIsAwardPointsModalOpen(false);
          setAwardPointsUser(null);
        }}
        loading={loadingAwardPoints}
        userName={
          awardPointsUser
            ? `${awardPointsUser.firstName} ${awardPointsUser.lastName}`
            : ''
        }
        isOpen={isAwardPointsModalOpen}
      />
      <DeductLoyaltyPointsModal
        onConfirm={handleDeductPoints}
        onClose={() => {
          setIsDeductPointsModalOpen(false);
          setDeductPointsUser(null);
        }}
        loading={loadingDeductPoints}
        userName={
          deductPointsUser
            ? `${deductPointsUser.firstName} ${deductPointsUser.lastName}`
            : ''
        }
        isOpen={isDeductPointsModalOpen}
      />
      <RemoveReferredByDoctorModal
        visible={isRemoveReferralModalOpen}
        onConfirm={handleRemoveReferredByDoctor}
        onCancel={() => {
          setIsRemoveReferralModalOpen(false);
          setRemoveReferralUser(null);
        }}
        loading={loadingRemoveReferral}
        userName={
          removeReferralUser
            ? `${removeReferralUser.firstName} ${removeReferralUser.lastName}`
            : ''
        }
      />
      <SetReferredByDoctorModal
        isOpen={isSetReferralModalOpen}
        onClose={() => {
          setIsSetReferralModalOpen(false);
          setSetReferralUser(null);
        }}
        onSuccess={loadUsers}
        user={setReferralUser}
      />
      <VerifyUserModal
        visible={isVerifyUserModalOpen}
        onConfirm={handleVerifyUser}
        onCancel={handleVerifyUserModalClose}
        loading={loadingVerifyingUser}
        userName={verifyUserName}
        {...(verifyMode === 'reactivate' && {
          title: 'Reaktiviraj korisnika',
          actionText: 'reaktivirate',
          confirmLabel: 'Reaktiviraj',
          loadingLabel: 'Reaktivacija...',
        })}
      />
    </>
  );
}
